module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-endCover"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__slogan"
  }), _vm._v(" "), _c('div', {
    ref: "actions",
    staticClass: "c-endCover__actions"
  }, [_c('span', {
    staticClass: "c-endCover__backBtn",
    on: {
      "click": _vm.handleBack
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-endCover__registerBtn",
    on: {
      "click": _vm.handleRegister
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-endCover__texts"
  }, [_c('div', {
    staticClass: "c-endCover__text line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__text line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__text line3"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__text line4"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1c28cbdc"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/show/EndCover.vue
// module id = 199
// module chunks = 1